module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_agder_pos.0c2d8763.png";